import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AttendanceTarget, ActualStatus } from './attendance.types';

@Component({
  selector: 'app-attendance-target-table', standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './attendance-target-table.component.html',
  styleUrls: ['./attendance-common.css', './attendance-target-table.component.css'],
})
export class AttendanceTargetTableComponent {
  @Input() targets: AttendanceTarget[]=[];
  @Input() selected = new Set<number>();
  @Input() editingLocked=false;
  @Input() canUpdateActual=false;
  @Output() selection = new EventEmitter<{id:number;checked:boolean}>();
  @Output() actual = new EventEmitter<{target:AttendanceTarget;next:ActualStatus;select:HTMLSelectElement}>();

  plannedLabel(status: string): string {
    return status === 'attending' ? '出席予定' : status === 'absent' ? '欠席予定' : '未回答';
  }

}
